import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { StochasticDashboardFilters } from "@/modules/stochastic/features/DashboardPage/components/DashboardFilters/StochasticDashboardFilters";
import { useStochasticDashboard } from "@/modules/stochastic/features/DashboardPage/hooks/useStochasticDashboard";
import TotalSalesNewVsExistingCustomerChart from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesNewVsExistingCustomerChart/TotalSalesNewVsExistingCustomerChart";
import RevenueByInvoiceAgeChart from "../Chart/RevenueByInvoiceAgeChart/RevenueByInvoiceAgeChart";
import TotalSalesNewCustomerByZipCodeAndYearChart from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesNewCustomerByZipCodeAndYearChart/TotalSalesNewCustomerByZipCodeAndYearChart";
import TotalSalesByYearAndMonthChart from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesByYearAndMonthChart/TotalSalesByYearAndMonthChart";
import TotalSalesByZipCodeChart from "../Chart/TotalSalesByZipCodeChart/TotalSalesByZipCodeChart";
import { PercentageOfNewCustomersByZipCodeChart } from "@/modules/stochastic/features/DashboardPage/components/Chart/PercentageOfNewCustomersByZipCodeChart/PercentageOfNewCustomersByZipCodeChart";
import CustomersAverageInvoiceComparisonChart from "@/modules/stochastic/features/DashboardPage/components/Chart/CustomersAverageInvoiceComparisonChart/CustomersAverageInvoiceComparisonChart";
import LifetimeValueByTierChart from "@/modules/stochastic/features/DashboardPage/components/Chart/LifetimeValueByTierChart/LifetimeValueByTierChart";
import { PercentageOfNewCustomersChangeByZipCodeTable } from "@/modules/stochastic/features/DashboardPage/components/Table/PercentageOfNewCustomersChangeByZipCodeTable/PercentageOfNewCustomersChangeByZipCodeTable";
import { LifetimeValueByTierTable } from "@/modules/stochastic/features/DashboardPage/components/Table/LifetimeValueByTierTable/LifetimeValueByTierTable";
import LifetimeValueByTierChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/LifetimeValueByTierChart/LifetimeValueByTierChartSkeleton";
import RevenueByInvoiceAgeChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/RevenueByInvoiceAgeChart/RevenueByInvoiceAgeChartSkeleton";
import { PercentageOfNewCustomersByZipCodeChartSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Chart/PercentageOfNewCustomersByZipCodeChart/PercentageOfNewCustomersByZipCodeChartSkeleton";
import { TotalSalesByYearAndMonthChartSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesByYearAndMonthChart/TotalSalesByYearAndMonthChartSkeleton";
import { TotalSalesByZipCodeChartSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesByZipCodeChart/TotalSalesByZipCodeChartSkeleton";
import TotalSalesNewCustomerByZipCodeAndYearChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesNewCustomerByZipCodeAndYearChart/TotalSalesNewCustomerByZipCodeAndYearChartSkeleton";
import TotalSalesNewVsExistingCustomerChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalSalesNewVsExistingCustomerChart/TotalSalesNewVsExistingCustomerChartSkeleton";
import { CustomersAverageInvoiceComparisonChartSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Chart/CustomersAverageInvoiceComparisonChart/CustomersAverageInvoiceComparisonChartSkeleton";
import { LifetimeValueByTierTableSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Table/LifetimeValueByTierTable/LifetimeValueByTierTableSkeleton";
import { PercentageOfNewCustomersChangeByZipCodeTableSkeleton } from "../Table/PercentageOfNewCustomersChangeByZipCodeTable/PercentageOfNewCustomersChangeByZipCodeTableSkeleton";
import NewCustomerReplacementEfficiencyChart from "@/modules/stochastic/features/DashboardPage/components/Chart/NewCustomerReplacementEfficiencyChart/NewCustomerReplacementEfficiencyChart";
import NewCustomerReplacementEfficiencyChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/NewCustomerReplacementEfficiencyChart/NewCustomerReplacementEfficiencyChartSkeleton";
import ExistingCustomerReplacementEfficiencyChart from "@/modules/stochastic/features/DashboardPage/components/Chart/ExistingCustomerReplacementEfficiencyChart/ExistingCustomerReplacementEfficiencyChart";
import ExistingCustomerReplacementEfficiencyChartSkeleton from "@/modules/stochastic/features/DashboardPage/components/Chart/ExistingCustomerReplacementEfficiencyChart/ExistingCustomerReplacementEfficiencyChartSkeleton";
import TotalHouseholdsByZipCodeChart from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalHouseholdsByZipCodeChart/TotalHouseholdsByZipCodeChart";
import { TotalHouseholdsByZipCodeChartSkeleton } from "@/modules/stochastic/features/DashboardPage/components/Chart/TotalHouseholdsByZipCodeChart/TotalHouseholdsByZipCodeChartSkeleton";

export default function DashboardPage() {
  const {
    dashboardData,
    dashboardFiltersForm,
    loading,
    activeTab,
    setActiveTab,
    applyFilters,
    areFiltersDirty,
  } = useStochasticDashboard();

  const renderSalesCharts = () => (
    <>
      <TotalSalesNewVsExistingCustomerChart
        initialData={dashboardData.totalSalesNewVsExistingCustomerData || []}
      />
      <TotalSalesByYearAndMonthChart
        initialData={dashboardData.totalSalesByYearAndMonthData}
      />
      <TotalSalesByZipCodeChart
        initialData={dashboardData.totalSalesByZipCodeData || []}
      />
      <TotalSalesNewCustomerByZipCodeAndYearChart
        initialData={dashboardData.totalSalesNewCustomerByZipCodeAndYearData}
      />
    </>
  );

  const renderSalesChartSkeletons = () => (
    <>
      <TotalSalesNewVsExistingCustomerChartSkeleton />
      <TotalSalesByYearAndMonthChartSkeleton />
      <TotalSalesByZipCodeChartSkeleton />
      <TotalSalesNewCustomerByZipCodeAndYearChartSkeleton />
    </>
  );

  const renderCustomerCharts = () => (
    <>
      <RevenueByInvoiceAgeChart
        initialData={dashboardData.revenueByInvoiceAgeData || []}
      />
      <LifetimeValueByTierChart
        initialData={dashboardData.lifetimeValueByTierData}
      />
      <LifetimeValueByTierTable
        initialData={dashboardData.lifetimeValueByTierData}
      />
      <PercentageOfNewCustomersByZipCodeChart
        initialData={dashboardData.percentageOfNewCustomersByZipCodeData}
      />
      <PercentageOfNewCustomersChangeByZipCodeTable
        initialData={
          dashboardData.percentageOfNewCustomersChangeByZipCodeData || []
        }
      />
      <CustomersAverageInvoiceComparisonChart
        initialData={dashboardData.customersAverageInvoiceComparisonData || []}
      />
      <NewCustomerReplacementEfficiencyChart
        initialData={dashboardData.newCustomerReplacementEfficiencyData || []}
        monthlyData={dashboardData.newCustomerReplacementEfficiencyByMonthData}
      />
      <ExistingCustomerReplacementEfficiencyChart
        initialData={
          dashboardData.existingCustomerReplacementEfficiencyData || []
        }
        monthlyData={
          dashboardData.existingCustomerReplacementEfficiencyByMonthData
        }
      />
    </>
  );

  const renderCustomerSkeletons = () => (
    <>
      <RevenueByInvoiceAgeChartSkeleton />
      <LifetimeValueByTierChartSkeleton />
      <LifetimeValueByTierTableSkeleton />
      <PercentageOfNewCustomersByZipCodeChartSkeleton />
      <PercentageOfNewCustomersChangeByZipCodeTableSkeleton />
      <CustomersAverageInvoiceComparisonChartSkeleton />
      <NewCustomerReplacementEfficiencyChartSkeleton />
      <ExistingCustomerReplacementEfficiencyChartSkeleton />
    </>
  );

  const renderReviewCharts = () => (
    <>
      <TotalSalesByYearAndMonthChart
        initialData={dashboardData.totalSalesByYearAndMonthData}
      />
      <RevenueByInvoiceAgeChart
        initialData={dashboardData.revenueByInvoiceAgeData || []}
      />
      <TotalSalesByZipCodeChart
        initialData={dashboardData.totalSalesByZipCodeData || []}
      />
      <TotalHouseholdsByZipCodeChart
        initialData={dashboardData.totalHouseholdsByZipCodeData}
      />
      <PercentageOfNewCustomersByZipCodeChart
        initialData={dashboardData.percentageOfNewCustomersByZipCodeData}
      />
      <CustomersAverageInvoiceComparisonChart
        initialData={dashboardData.customersAverageInvoiceComparisonData || []}
      />
      <NewCustomerReplacementEfficiencyChart
        initialData={dashboardData.newCustomerReplacementEfficiencyData || []}
        monthlyData={dashboardData.newCustomerReplacementEfficiencyByMonthData}
      />
      <ExistingCustomerReplacementEfficiencyChart
        initialData={
          dashboardData.existingCustomerReplacementEfficiencyData || []
        }
        monthlyData={
          dashboardData.existingCustomerReplacementEfficiencyByMonthData
        }
      />
      <LifetimeValueByTierChart
        initialData={dashboardData.lifetimeValueByTierData}
      />
    </>
  );

  const renderReviewChartSkeletons = () => (
    <>
      <TotalSalesByYearAndMonthChartSkeleton />
      <RevenueByInvoiceAgeChartSkeleton />
      <TotalSalesByZipCodeChartSkeleton />
      <TotalHouseholdsByZipCodeChartSkeleton />
      <PercentageOfNewCustomersByZipCodeChartSkeleton />
      <CustomersAverageInvoiceComparisonChartSkeleton />
      <NewCustomerReplacementEfficiencyChartSkeleton />
      <ExistingCustomerReplacementEfficiencyChartSkeleton />
      <LifetimeValueByTierChartSkeleton />
    </>
  );

  const renderChartSkeletons = () => {
    if (activeTab === "sales") return renderSalesChartSkeletons();
    if (activeTab === "customers") return renderCustomerSkeletons();
    return renderReviewChartSkeletons();
  };

  const renderCharts = () => {
    if (activeTab === "sales") return renderSalesCharts();
    if (activeTab === "customers") return renderCustomerCharts();
    return renderReviewCharts();
  };

  return (
    <MainPageWrapper loading={loading} title="Stochastic Dashboard">
      <div className="bg-white dark:bg-secondary-dark min-h-screen transition-colors duration-200">
        <StochasticDashboardFilters
          activeTab={activeTab}
          areFiltersDirty={areFiltersDirty}
          chartFiltersForm={dashboardFiltersForm}
          onApplyFilters={applyFilters}
          setActiveTab={setActiveTab}
        />
        <div className="max-w-7xl mx-auto space-y-8">
          {loading ? renderChartSkeletons() : renderCharts()}
        </div>
      </div>
    </MainPageWrapper>
  );
}
